import { Close } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { CopyToClipboard } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

export interface MgItemInfoProps {
  primaryText: string;
  secondaryText?: string;
  mgItemNumber: number;
  closeProductCard: () => void;
}

export const MgItemInfo = ({
  primaryText,
  secondaryText,
  mgItemNumber,
  closeProductCard,
}: MgItemInfoProps) => {
  const t = useMyAssortmentTFunction();
  return (
    <Stack
      p={2}
      pb={0}
      minHeight={94}
      alignItems="flex-start"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Stack flexGrow={1} alignItems="flex-start">
        <Typography variant="subtitle1">{primaryText}</Typography>

        {secondaryText && <Typography variant="body2">{secondaryText}</Typography>}

        <CopyToClipboard value={mgItemNumber}>
          <Stack direction="row" gap={1}>
            <Typography variant="body2">{t('myAssortment.productCard.mgItemNr')}:</Typography>
            <Typography variant="subtitle2" fontWeight="bold">
              {mgItemNumber}
            </Typography>
          </Stack>
        </CopyToClipboard>
      </Stack>

      <IconButton sx={{ p: 0 }} onClick={closeProductCard}>
        <Close />
      </IconButton>
    </Stack>
  );
};
